import { doFetchAPI } from './default';
import { doResetSearch, doSearchAPI } from './search';

export default {
  doFetchAPI,
  doResetSearch,
  doSearchAPI,
};
